import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DigitalCVModel, ProfileCompletionModel } from '@digilize/shared/definitions/src';
import { Subject, takeUntil } from 'rxjs';

import { SharedAccountDataService } from '../../services/shared-account-data.service';

interface SkillCompletionItem {
  labelKey: string;
  completionKey: keyof ProfileCompletionModel;
}

@Component({
  selector: 'bwc-skills-completion',
  templateUrl: './skills-completion.component.html',
  styleUrls: ['./skills-completion.component.scss'],
})
export class SkillsCompletionComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  private readonly cvService = inject(SharedAccountDataService);
  cv: DigitalCVModel | null = null;
  readonly skillsList: SkillCompletionItem[] = [
    { labelKey: 'global.general_information', completionKey: 'general_info' },
    { labelKey: 'global.knowledge_and_skills', completionKey: 'knowledge' },
    { labelKey: 'global.soft_skills', completionKey: 'soft_skills' },
    { labelKey: 'global.languages', completionKey: 'language_skills' },
    { labelKey: 'global.your_experience', completionKey: 'professions' },
    { labelKey: 'global.your_education', completionKey: 'education' },
    { labelKey: 'work_preferences.title', completionKey: 'work_preference' },
    { labelKey: 'global.profile_visibility', completionKey: 'profile_visibility' },
  ];

  profileCompletion: ProfileCompletionModel | null = null;

  ngOnInit(): void {
    this.cvService.cv$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (cv: DigitalCVModel) => {
        this.cv = cv;
        this.profileCompletion = cv.profile_completion ?? null;
      },
    });
  }

  checkSkillState(completionKey: keyof ProfileCompletionModel): boolean {
    return !!this.profileCompletion?.[completionKey];
  }

  checkGeneralState(): boolean {
    return !!this.cv?.email && !!this.cv?.last_name && !!this.cv?.first_name;
  }

  get completionPercentage(): number {
    if (!this.profileCompletion) {
      return 0;
    }

    return Math.round(this.profileCompletion.profile_completeness);
  }
}
